export const bytesToMb = (bytes) => {
  const kb = bytes / 1024;
  const mb = kb / 1024;

  return mb.toFixed(2);
};
